import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../../components/ui/Header';
import Breadcrumb from '../../components/ui/Breadcrumb';
import HeroSection from './components/HeroSection';
import CompanyStory from './components/CompanyStory';
import StatisticsSection from './components/StatisticsSection';
import PremiumRotatingSection from './components/PremiumRotatingSection';
import { initSmoothScroll } from '../../utils/smoothScroll';
import SEO from '../../components/SEO';

const AboutCompany = () => {
  const { t } = useTranslation('about');
  
  useEffect(() => {
    initSmoothScroll();
  }, []);

  return (
    <>
      <SEO 
        titleKey="about.title" 
        descriptionKey="about.description" 
        pagePath="about" 
      />

      <div className="min-h-screen" >
        <Header />
        
        <main className="pt-20">
          <div className="container mx-auto px-6 lg:px-8">
            <Breadcrumb />
          </div>
          
          <HeroSection />
          <CompanyStory />
          <PremiumRotatingSection />

        </main>
      </div>
    </>
  );
};

export default AboutCompany;